import React, { Suspense, ComponentType, ComponentProps } from 'react'

import { Spinner } from './Spinner'

export const wrapSuspenseComponent = <T extends {}>(Comp: ComponentType<T>) => {
  return (props: ComponentProps<typeof Comp>) => {
    return (
      <Suspense fallback={<Spinner size='$9' color='$darkBlue9' />}>
        <Comp {...props} />
      </Suspense>
    )
  }
}
